var _a, _b, _c;
export const internalDateFormat = {
    flatpickr: 'Y-m-dTH:i',
    moment: 'YYYY-MM-DDTHH:mm',
};
export const screenReaderContent = (_b = (_a = window === null || window === void 0 ? void 0 : window.s__) === null || _a === void 0 ? void 0 : _a.call(window, 'Enter the date with your keyboard in the following format: %{format}')) === null || _b === void 0 ? void 0 : _b.i__({ format: (_c = window === null || window === void 0 ? void 0 : window.I18n) === null || _c === void 0 ? void 0 : _c.t('date.formats.date_picker') });
export const attributesToCopy = [
    'aria-describedby',
    'aria-invalid',
    'aria-label',
    'aria-required',
    'autocomplete',
];
//# sourceMappingURL=constants.js.map